export default {
    title: {
        USER_ALREADY_HAS_ACCESS: 'Acceso ya existe',
        invalidInvite: 'Convite inválido',
    },
    text: {
        USER_ALREADY_HAS_ACCESS: 'El usuario ya tiene este acceso. Retorne para la pantalla de inicio de sesión.',
        invalidInvite: 'El convite utilizado ha sido invalidado. Solicite el envío de un nuevo convite.',
    },
    button: 'Ir para inicio de sesión'
}